import moment from "moment";
const formatUserData = function(id, item) {
    const data = item;
    if( typeof item !== 'undefined' ){
        data.uid = item.uid != undefined ? item.uid : id;
        data.name = item.firstname + " " + item.lastname; 
        data.avatar = item.pictureUrl
        data.roleText = (item.role == 'challengeAdmin' )? 'Admin' : 'Super Admin';

        //calculate age
        data.age = 0;
        data.birthdateText = '';
        if( data.birthdate != undefined ){
            const a = moment(data.birthdate.toDate(), "YYYY-MM-DD");
            const b = moment(new Date(), "YYYY-MM-DD");
            data.age = b.diff(a, 'years');
            data.birthdateText = a.format("YYYY-MM-DD");
        }
    }
    
    return data;
};
export default formatUserData;